import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  connect() {
    const role = this.element.dataset.role;
    if (!role) {
      return;
    }
    this.timeoutId = setTimeout(() => {
      this.element.setAttribute("role", role);
    }, 300);
  }
  disconnect() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}
